import { css, FlattenSimpleInterpolation } from 'styled-components';

export type Color = string; // TODO add v2 colors type here

export const color = (color: Color = '#141D1E'): FlattenSimpleInterpolation => css`
  ${color ? `color: ${color};` : ''}
`;
